module.exports = __webpack_public_path__ + "assets/Equilateral3Detailed.19c77375153cc4a0cec2cb72a33f23c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Equilateral3Detailed.png
// module id = 508
// module chunks = 0